import { useEffect } from "react";
import { useSite } from "../context/SiteContext";
import { useI18n } from "../i18n/I18nContext";

// Keeps the browser tab title in sync with the editable company name.
export default function DocumentTitle() {
    const { site } = useSite();
    const { lang, t } = useI18n();

    useEffect(() => {
        const identity = site?.identity || {};
        const name = identity[lang === "en" ? "name_en" : "name_fr"] || identity.name_fr || t("brand.name");
        const sub = identity[lang === "en" ? "sub_en" : "sub_fr"] || identity.sub_fr || t("brand.sub");
        document.title = sub ? `${name} — ${sub}` : name;
    }, [site, lang, t]);

    return null;
}
